import styled from 'styled-components'
import { Title2, CardTitle, Micro } from '@thriveglobal/thrive-ui-lib'
import Link from '@elements/Link'
import { COLORS } from '@enums/colors'

export const CloseHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1rem 0;
  cursor: pointer;
`

export const LoginContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 3rem 3rem;
`

export const LoginTitle = styled(Title2)`
  margin-bottom: 0.2rem;
`

export const LoginSubTitle = styled(CardTitle)`
  font-family: 'Open Sans';
`

export const LoginLink = styled(Link)`
  font-size: 0.8rem;
  line-height: 1rem;
  font-family: 'Open Sans';
  margin: 0;
  cursor: pointer;
  color: ${COLORS.teal};
`

export const RequestDemoLink = styled(LoginLink)`
  margin-top: 2.5rem;
`

export const InvalidEmailInformation = styled(Micro)`
  display: block;
  font-family: 'Open Sans';
  margin: 0.4rem 0 0;
`
